import { createActionThunk } from "redux-thunk-actions";

import {
  getNotifs,
  deleteNotifs as deleteNotifsService,
  acceptNotifs as acceptNotifsService,
} from "../services/InboxService";
import { getIngredients } from "../services/RecipeService";
import {
  getFailed,
  getStarted,
  getSucceeded,
  INBOX_INITIALIZATION,
  INBOX_INGREDIENT_TOGGLE,
  INBOX_SELECT_TOGGLE,
  INBOX_DELETE,
  INBOX_FILTER,
  INBOX_CATEGORY_SELECTED,
  INBOX_ACCEPT,
  CLEAR_INBOX,
} from "./constant";

const initialization = createActionThunk(INBOX_INITIALIZATION, () =>
  getNotifs()
);
const categorySelected = (cat) => {
  return (dispatch) => {
    dispatch({
      type: INBOX_CATEGORY_SELECTED,
      cat: cat,
    });
  };
};
const ingredientToggle = (id, isExpand, isDone) => {
  if (isExpand || (typeof isDone != "undefined" && isDone)) {
    return (dispatch) => {
      dispatch({
        type: INBOX_INGREDIENT_TOGGLE,
        item: { _id: id },
      });
    };
  } else {
    return async (dispatch) => {
      try {
        const recipe = {
          id: id,
        };
        let data = await getIngredients(recipe);
        dispatch({
          type: INBOX_INGREDIENT_TOGGLE,
          item: data,
        });
      } catch (e) {
        console.log(e);
        // return dispatch({type: getFailed(GET_RECIPE), error: e});
      }
    };
  }
};
const inboxFilter = (sortBy) => {
  return (dispatch) => {
    dispatch({
      type: INBOX_FILTER,
      sortBy: sortBy,
    });
  };
};
const notifSelectToggle = (item) => {
  return (dispatch) => {
    dispatch({
      type: INBOX_SELECT_TOGGLE,
      id: item._id,
      item: item.name,
      cat: item.category,
    });
  };
};
const deleteNotifs = createActionThunk(INBOX_DELETE, (ids) =>
  //   deleteRecipesService(ids, cat)
  deleteNotifsService(ids)
);
const acceptNotifs = createActionThunk(INBOX_ACCEPT, (ids) =>
  //   deleteRecipesService(ids, cat)
  acceptNotifsService(ids)
);

const clearInbox = () => {
  return async (dispatch) => {
    dispatch({
      type: CLEAR_INBOX,
    });
  };
};

export default {
  initialization,
  ingredientToggle,
  inboxFilter,
  clearInbox,
  notifSelectToggle,
  deleteNotifs,
  categorySelected,
  acceptNotifs,
  //   onChangeMealPlanner,
  //   onSubmitMealPlanner,
  //   shareChange,
  //   share,
};



// WEBPACK FOOTER //
// ./src/actions/inboxActions.js